import { render, staticRenderFns } from "./PropertyView.vue?vue&type=template&id=d0a5771a&scoped=true"
import script from "./PropertyView.vue?vue&type=script&lang=js"
export * from "./PropertyView.vue?vue&type=script&lang=js"
import style0 from "./PropertyView.vue?vue&type=style&index=0&id=d0a5771a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a5771a",
  null
  
)

export default component.exports